import { Typography } from '@prenuvo/halo-web';
import Countdown from 'react-countdown';

interface TimerProps {
  onTimerEnd: () => void;
  utsStart: number;
}

interface CounterProps {
  minutes: number;
  seconds: number;
  completed: boolean;
}

const checkTimeLeft = (minutes: number) => {
  if (minutes <= 1) {
    return 'Holding your spot for 1 minute';
  } else if (minutes <= 2) {
    return 'Holding your spot for 2 minutes';
  } else if (minutes <= 5) {
    return 'Holding your spot for 5 minutes';
  } else if (minutes <= 10) {
    return 'Holding your spot for 10 minutes';
  } else {
    return 'Holding your spot for 20 minutes';
  }
};

const counter = ({ minutes, seconds, completed }: CounterProps) => {
  if (completed) {
    return null;
  } else {
    return (
      <div className="flex justify-between align-baseline">
        <span aria-live="assertive" className="sr-only">
          {checkTimeLeft(minutes)}
        </span>
        <span className="hidden pr-2 font-light text-inactive md:inline">|</span>
        <Typography variant="paragraph-sm" as="span" className="text-inactive">
          Holding your spot for:
        </Typography>
        <Typography
          variant="paragraph-md-bold"
          as="span"
          className="ml-2"
          aria-label={`${minutes} minutes and ${seconds} seconds`}
        >
          {minutes}m {seconds}s
        </Typography>
      </div>
    );
  }
};

export default function Timer({ onTimerEnd, utsStart }: TimerProps) {
  return (
    <Countdown
      // 20 minutes
      date={Math.floor(utsStart * 1000 + 1200000)}
      renderer={counter}
      onComplete={onTimerEnd}
    />
  );
}
